// jQuery is loaded by theme.js, which can finish after DOMContentLoaded — binding
// straight away threw "$ is not defined" and the thumbnails never opened the player.
function whenJQueryReady(fn, tries) {
  tries = tries || 0;
  // Always defer by a tick: the helpers below are `const`, so running fn()
  // synchronously while this file is still being evaluated hits the temporal
  // dead zone ("Cannot access 'toggleStoryModal' before initialization").
  if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) return setTimeout(fn, 0);
  if (tries > 100) return;
  setTimeout(function () { whenJQueryReady(fn, tries + 1); }, 100);
}

whenJQueryReady(() => {
  const story_thumbnails = $('.video__block')
  
  story_thumbnails.on('click', async (event) => {
    const feedContainer = $('.feed__container')
    const slickIndex = $(event.target).closest('.video__block').index()
    $('.story-modal .loader__container').toggleClass('active')
    toggleStoryModal()
    await loadStories()
    setTimeout(() => {
      feedContainer.slick('slickGoTo', parseInt(slickIndex, 10));
      $('.story-modal .loader__container').toggleClass('active')
    }, 0)
  })
  
  $('#closeStory').on('click', toggleStoryModal)

  $('.feed__container').on('click', toggleVideo)
  $('#toggleVolume').on('click', toggleVolume)
})

const toggleVideo = () => {
    const currentSlide = $('.feed__container').slick('slickCurrentSlide');
    const slickInstance = $('.feed__container').slick('getSlick');
    const video = $(slickInstance.$slides[currentSlide]).find('video').get(0);

    if (video) {
        if (video.paused) {
            video.play();
            $('.play-button').css('opacity', '0')
        } else {
            video.pause();
            $('.play-button').css('opacity', '1')
        }
    }
}


const toggleStoryModal = () => {
  const modal = document.getElementById('storyModal');
  if (modal.classList.contains('fadeIn')) {
     modal.classList.remove('fadeIn')
     modal.classList.add('fadeOut')
      $('.FeedVideo__container video').each(function() {
          this.pause();
      });
  } else {
     modal.classList.remove('fadeOut')
     modal.classList.add('fadeIn')
    loadStories()
  }
}

const loadStories = async () => {
  const story_thumbnails = $('.video__block')
  let feed = ''
  const feedContainer = $('.feed__container')

  
  feedContainer.on('afterChange', (event, slick, currentSlide) => {
    $('.FeedVideo__container video').each(function() { // PAUSE ALL VIDEOS
        this.pause();
    });

    $('.play-button').css('opacity', '0')

    
    const currentVideo = $(slick.$slides[currentSlide]).find('video').get(0); // PLAY CURRENT VIDEO
    if(currentVideo) {
        currentVideo.play();
    }

    resetVolumes() // RESET ALL VOLUMES
    const currentIndex = $(slick.$slides[currentSlide]).attr('data-slick-index')
    const currentProduct = $(`.video__block[data-product='${currentVideo.getAttribute('data-product')}']`)
    updateStoryProduct(currentProduct.attr('data-product'), currentProduct.attr('data-variant'), currentProduct.attr('data-product-title'), currentProduct.attr('data-product-price'), currentProduct.attr('data-product-image'))
  })
  
  await story_thumbnails.each((index, element) => {
    const html_block = `
      <div class="FeedVideo__container">
        <video 
          loop
          crossorigin="true" 
          playsinline=""
          controlslist="nodownload noplaybackrate"
          disablepictureinpicture=""
          data-video-index="${index}"
          data-product="${element.getAttribute('data-product')}"
          class="story__player"
          src="${element.getAttribute('data-video')}" 
          preload="metadata">
          <track kind="metadata" label="cuepoints" data-removeondestroy="">
        </video>
      </div>`
    feed += html_block
  })

  feedContainer.html(feed)

  setTimeout(() => {
    if (feedContainer.hasClass('slick-initialized')) {
      feedContainer.slick('unslick'); 
    }
    
    feedContainer.not('.slick-initialized').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true,
      verticalSwiping: true,
      adaptiveHeight: true,
      prevArrow: $('#prevStory'),
      nextArrow: $('#nextStory'),
      lazyLoad: 'progressive'
    })  
  }, 0)
}

const toggleVolume = () => {
  const feedContainer = $('.feed__container')
  const currentSlide = feedContainer.slick('slickCurrentSlide');
  const video = feedContainer.find('.slick-slide[data-slick-index="' + currentSlide + '"]').find('video').get(0);
  
  if (video) {
      if (video.volume > 0) {
        video.volume = 0;
        $('#toggleVolume .volume-on').removeClass('active')
        $('#toggleVolume .volume-off').addClass('active')
      } else {
        video.volume = 1;
        $('#toggleVolume .volume-on').addClass('active')
        $('#toggleVolume .volume-off').removeClass('active')
      }
  }
}

const resetVolumes = () => {
  $('.FeedVideo__container video').each(function() {
    this.volume = 1
  });
  $('#toggleVolume .volume-on').addClass('active')
  $('#toggleVolume .volume-off').removeClass('active')
}

const updateStoryProduct = (productId, variantId, title, price, image) => {
  const sizes = [
    { width: 200, descriptor: '200w' },
    { width: 300, descriptor: '300w' },
    { width: 400, descriptor: '400w' },
    { width: 500, descriptor: '500w' },
    { width: 600, descriptor: '600w' }
  ];
  
  let imageString = sizes.map(size => {
    return `${image}&width=${size.width} ${size.descriptor}`;
  }).join(', ');
  
  $('.story__product__content .h4').fadeOut('fast', function() {
    $(this).text(title).fadeIn('fast');
  });

  $('.story__product__content .price').fadeOut('fast', function() {
    $(this).text(price).fadeIn('fast');
  });

  $('.story__product img').fadeTo('fast', 0.3, function() {
    $(this).attr('srcset', imageString).fadeTo('fast', 1);
    $(this).attr('src', image).fadeTo('fast', 1);
  });

  $('.story__product__content .product-single__variants option').val(variantId)
  $('.story__product__content .product-single__variants').val(variantId).trigger('change');
  $('.story__product__content form input[name="product-id"]').val(productId)
  console.log($('.story__product__content .product-single__variants').val() + " - " + variantId)
}
